// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3b1SB","content":"ManualTimeModal_content__1ZxP_"};